// extracted by mini-css-extract-plugin
export default {"container":"Brand_container__ADp8F","content":"Brand_content__vPzku","img":"Brand_img__0AmK7","title":"Brand_title__Bg5Nr","description":"Brand_description__9jEgn"};